import * as React from "react";
import { Scrollbars } from "react-custom-scrollbars";

import "./CustomScrollbar.css";

interface CustomScrollbarProps {
  children: JSX.Element | JSX.Element[];
  minHeight?: number;
  maxHeight?: number;
}

const CustomScrollbar = (customScrollbarProps: CustomScrollbarProps) =>
  <Scrollbars
    autoHeight
    autoHeightMin={customScrollbarProps.minHeight}
    autoHeightMax={customScrollbarProps.maxHeight}
    className="custom-scrollbar"
    renderTrackVertical={props =>
      <div {...props} className="custom-scrollbar__vertical-track" />}
    renderThumbVertical={props =>
      <div {...props} className="custom-scrollbar__vertical-thumb" />}
    renderTrackHorizontal={props =>
      <div {...props} className="custom-scrollbar__horizontal-track" />}
    renderThumbHorizontal={props =>
      <div {...props} className="custom-scrollbar__horizontal-thumb" />}
  >
    {customScrollbarProps.children}
  </Scrollbars>;

export default CustomScrollbar;



// WEBPACK FOOTER //
// ./src/components/CustomScrollbar.tsx